import React from 'react'
import clsx from 'clsx'
import { Dialog, DialogContent, Grow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  ConfirmModal,
  SignUpConfirmModal,
  ConfirmDeleteSurveyModal,
  AddFieldsFromAnotherModal,
  BulkImportFieldMatchModal,
  LoginModal,
  AccountEditModal,
  AllinOneImageUploadModal,
} from '~/legacy/components/modals'

export const MODALS = {
  SIGN_UP_CONFIRM: 'signUpConfirm',
  ALL_IN_ONE_IMAGE_UPLOAD: 'allInOneImageUpload',
  CONFIRM_DELETE_SURVEY: 'confirmDeleteSurvey',
  ADD_FIELDS_FROM_ANOTHER: 'addFieldsFromAnother',
  BULK_IMPORT_FIELD_MATCH: 'BULK_IMPORT_FIELD_MATCH',
  LOGIN_MODAL: 'loginModal',
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  ACCOUNT_EDIT_MODAL: 'accountEditModal',
}

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noPadding: {
    padding: 0,
    '&:first-child': {
      padding: 0,
    },
  },
  fullHeight: {
    height: '100%',
  },
})

const OpenCloseTransition = React.forwardRef((props, ref) => {
  return <Grow ref={ref} {...props} />
})

function Modal({
  content,
  childProps,
  fullScreen = false,
  open,
  onClose,
  disableBackDropClickClose = false,
}) {
  const classes = useStyles()
  const getContentComponent = () => {
    switch (content) {
      case MODALS.SIGN_UP_CONFIRM:
        return <SignUpConfirmModal />
      case MODALS.ALL_IN_ONE_IMAGE_UPLOAD:
        return <AllinOneImageUploadModal />
      case MODALS.CONFIRM_DELETE_SURVEY:
        return <ConfirmDeleteSurveyModal />
      case MODALS.ADD_FIELDS_FROM_ANOTHER:
        return <AddFieldsFromAnotherModal />
      case MODALS.BULK_IMPORT_FIELD_MATCH:
        return <BulkImportFieldMatchModal {...childProps} />
      case MODALS.LOGIN_MODAL:
        return <LoginModal />
      case MODALS.CONFIRM_MODAL:
        return <ConfirmModal onClose={onClose} {...childProps} />
      case MODALS.ACCOUNT_EDIT_MODAL:
        return <AccountEditModal {...childProps} />
      default:
        return null
    }
  }

  return (
    <Dialog
      id="dialog-backdrop"
      className={classes.modal}
      fullScreen={fullScreen}
      maxWidth={false}
      open={open}
      onClose={(event, reason) => {
        if (!disableBackDropClickClose || reason !== 'backdropClick') {
          onClose(event, reason)
        }
      }}
      TransitionComponent={OpenCloseTransition}
    >
      <DialogContent
        className={clsx(
          childProps && childProps.noPadding && classes.noPadding,
          childProps && childProps.fullHeight && classes.fullHeight,
          childProps && childProps.contentClassName
        )}
      >
        {React.cloneElement(getContentComponent(), {
          ...childProps,
          onClose,
        })}
      </DialogContent>
    </Dialog>
  )
}

export default Modal
